import React from 'react';

export default props => (
	<React.Fragment>
		<section className="content-header">
			<h1>
				{props.title}
				<small>{props.subtitle}</small>
			</h1>
			{/* {props.breadcrumb} */}
			{/* <ol className="breadcrumb">
				<li>
					<a href="#">
						<i className="fa fa-dashboard" /> Home
					</a>
				</li>
				<li>
					<a href="#">Forms</a>
				</li>
				<li className="active">Advanced Elements</li>
			</ol> */}
		</section>
	</React.Fragment>
);
